import { graphql } from "../gql";

export const userTenantNameQueryDoc = graphql(`
  query getUserTenantName {
    userTenantName
  }
`);
